import {
  AfterViewInit,
  Component,
  DoCheck,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import {Example} from '../../shared/models/example.model';
import {ExampleSJ} from '../../shared/models/word.model';
import {VoiceService} from '../../shared/services/voice/voice.service';

@Component({
  selector: 'app-example-list-item',
  templateUrl: './example-list-item.component.html',
  styleUrls: ['./example-list-item.component.scss']
})
export class ExampleListItemComponent implements AfterViewInit, OnChanges, DoCheck {
  @HostBinding('style.display') styleBlock = 'block';
  @Input() example: Example;
  @Input() select = false;
  exampleSJ: ExampleSJ | null = null;
  public showSeungjo = false;

  constructor(
    private elRef: ElementRef,
    private voice: VoiceService,
  ) {
  }

  ngAfterViewInit(): void {
    this.example.offsetTop = this.elRef.nativeElement.offsetTop;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.select || changes.example) {
      this.exampleSJ = this.example?.toExampleSJ() ?? null;
    }
  }

  ngDoCheck(): void {
    const activeId = this.voice.exampleId;
    if (activeId === null) {
      return;
    }
    this.showSeungjo = activeId === this.example?.id;
  }

  public ClearSeungjo(): void {
    this.showSeungjo = false;
  }
}
